<template>
  <SettingsModal v-model:visible="isVisible" />
</template>

<script setup>
import SettingsModal from './SettingsModal.vue';
import { useGlobalSettings } from '../composables/useGlobalSettings';

defineOptions({ name: 'GlobalSettingsModal' });

const { isVisible } = useGlobalSettings();
</script>
